module.exports = __webpack_public_path__ + "img/btn_ly_close.85066254.svg";